<mat-tab-group mat-stretch-tabs="false" class="matTab" (selectedIndexChange)="selectedIndexChangeNew($event)"
    [selectedIndex]="selectedIndexo">


    <mat-tab label="Project Name">
        <div class="matContent">
            <mat-card class="uploadxls">

                <form id="uploadxl" class="example-form" [formGroup]="importxls">

                    <mat-card-content>


                        <mat-form-field class="example-full-width col-md-4">
                            <input [(ngModel)]="projectName" matInput placeholder="Please enter project name"
                                formControlName="xlspath">
                        </mat-form-field><br><br>





                        <button id="actcost" (click)="uploadImage()" type="button" mat-raised-button
                            color="primary">Submit</button>


                        <button (click)="clickMeBack()" class="backTop" mat-raised-button
                            color="default">Cancel</button>


                        <br><br>


                    </mat-card-content>
                </form>



            </mat-card>



        </div>
    </mat-tab>


    <mat-tab label="Project Data">

        <div class="matContent">
            <mat-card class="uploadxls">
                <div *ngIf='num_rec'>
                    {{num_rec.num_records}} records are uploaded.
                </div>

                Please fill following information in CSV file: <br />
                User ID : {{testusid }} <br />
                Project ID: {{ prid }} <br />
                To upload xls follow these steps<br />
                1. Login to Adeos FTP server with given credentials using FTP Client like Filezila.<br />
                2. Upload project.xls to the path : /home/adeosvm6/tmp/ <br />
                3. Update the upload_reading.xls and upload_loadresults.xls with the newly created user_id and proj_id
                and upload it to the path : /home/adeosvm6/tmp/ <br />
                4. Once upload is done, click on Import XLS below.<br /><br />
                <div class="d-flex">
                <button class="backTop mr-2" (click)="clickMeBack()" class="backTop" mat-raised-button
                    color="default">Back</button>
                <button id="actcost" (click)="Upload_data()" class="back" mat-raised-button color="default">Import
                    XLS</button>
                <button id="actcost" (click)="removeStorage()" class="back" mat-raised-button color="default">Remove
                    storage</button>
                <button id="actcost" [disabled]='chk_stat' (click)="get_exp_rec()" class="backcheck" mat-raised-button
                    color="default">Check records</button>
                </div>
               

            </mat-card>



        </div>
    </mat-tab>

</mat-tab-group>